import { mutatorAction } from "satcheljs";
import { shiftEditorViewState } from "..";

export default mutatorAction("setIsAllDay", function setIsAllDay(isAllDay: boolean) {
    shiftEditorViewState().isAllDay = isAllDay;
});
